/* eslint-disable */
import PropTypes from 'prop-types';
import * as React from 'react';

import { Box, Checkbox, IconButton, TableCell, TableHead, TableRow, TableSortLabel, Toolbar, Tooltip, Typography } from '@mui/material';
import { visuallyHidden } from '@mui/utils';

import DeleteIcon from '@mui/icons-material/Delete';
import { openConfirmationModal } from 'store/slices/confirmationModal';
import { RequestActions } from 'store/slices/requests';
import { dispatch } from 'store';
import { openSnackbar } from 'store/slices/snackbar';
import useAuth from 'hooks/useAuth';

import { roles } from 'store/constant';

const headCells = [
    {
        id: 'status',
        numeric: false,
        label: 'Status',
        align: 'center'
    },
    {
        id: 'listingId',
        numeric: false,
        label: 'Listing ID',
        align: 'center'
    },

    {
        id: 'manager',
        numeric: false,
        label: 'Manager',
        align: 'center',
        disablePadding: true
    },
    {
        id: 'complexName',
        numeric: false,
        label: 'Complex Name',
        align: 'center'
    },
    {
        id: 'floorPlanName',
        numeric: false,
        label: 'Floor Plan',
        align: 'center'
    },
    {
        id: 'unit',
        numeric: false,
        label: 'Unit #',
        align: 'center'
    },
    {
        id: 'price',
        numeric: false,
        label: 'Price',
        align: 'center'
    },
    {
        id: 'livingArea',
        numeric: false,
        label: 'Sq Ft Area',
        align: 'center'
    },
    {
        id: 'mainLevelBedrooms',
        numeric: false,
        label: 'Beds',
        align: 'center'
    },
    {
        id: 'bathroomsFull',
        numeric: false,
        label: 'Baths',
        align: 'center'
    },
    {
        id: '',
        numeric: false,
        label: 'Details',
        align: 'center'
    }
];

const headCellsAM = [
    {
        id: 'listingId',
        numeric: false,
        label: 'Listing ID',
        align: 'center'
    },
    {
        id: 'status',
        numeric: false,
        label: 'Status',
        align: 'center'
    },
    {
        id: 'floorPlanName',
        numeric: false,
        label: 'Floor Plan',
        align: 'center'
    },
    {
        id: 'unit',
        numeric: false,
        label: 'Unit #',
        align: 'center'
    },
    {
        id: 'price',
        numeric: false,
        label: 'Price',
        align: 'center'
    },
    {
        id: 'livingArea',
        numeric: false,
        label: 'Sq Ft Area',
        align: 'center'
    },
    {
        id: 'mainLevelBedrooms',
        numeric: false,
        label: 'Beds',
        align: 'center'
    },
    {
        id: 'bathroomsFull',
        numeric: false,
        label: 'Baths',
        align: 'center'
    },
    {
        id: '',
        numeric: false,
        label: 'Details',
        align: 'center'
    }
];

const headAdminCell = [
    {
        id: 'status',
        numeric: false,
        label: 'Status',
        align: 'center'
    },
    {
        id: 'listingId',
        numeric: false,
        label: 'Listing ID',
        align: 'center',
        width: '100px'
    },
    {
        id: 'manager',
        numeric: false,
        label: 'Manager',
        align: 'center',
        disablePadding: true,
        width: '150px'
    },
    {
        id: 'complexName',
        numeric: false,
        label: 'Complex Name',
        align: 'center',
        width: '130px'
    },
    {
        id: 'floorPlanName',
        numeric: false,
        label: 'Floor Plan',
        align: 'center',
        width: '130px'
    },
    {
        id: 'unit',
        numeric: false,
        label: 'Unit #',
        align: 'center',
        width: '100px'
    },
    {
        id: 'price',
        numeric: false,
        label: 'Price',
        align: 'center'
    },
    {
        id: '',
        numeric: false,
        label: 'Details',
        align: 'center',
        width: '200px'
    }

    // {
    //     id: 'listing_rate',
    //     numeric: false,
    //     label: 'Listing Rate',
    //     align: 'center'
    // },
    // {
    //     id: 'actions',
    //     numeric: false,
    //     label: 'Action',
    //     align: 'center',
    //     width: '150px'
    // }
];

const headArchieveAdminCell = [
    {
        id: 'status',
        numeric: false,
        label: 'Status',
        align: 'center'
    },
    {
        id: 'listingId',
        numeric: false,
        label: 'Listing ID',
        align: 'center',
        width: '100px'
    },

    {
        id: 'manager',
        numeric: false,
        label: 'Manager',
        align: 'center',
        disablePadding: true,
        width: '150px'
    },
    {
        id: 'complexName',
        numeric: false,
        label: 'Complex Name',
        align: 'center',
        width: '130px'
    },
    {
        id: 'floorPlanName',
        numeric: false,
        label: 'Floor Plan',
        align: 'center',
        width: '130px'
    },
    {
        id: 'unit',
        numeric: false,
        label: 'Unit #',
        align: 'center',
        width: '100px'
    },
    {
        id: 'price',
        numeric: false,
        label: 'Price',
        align: 'center'
    },
    {
        id: '',
        numeric: false,
        label: 'Archived Status',
        align: 'center'
    },
    {
        id: '',
        numeric: false,
        label: 'Details',
        align: 'center',
        width: '200px'
    }
];

function EnhancedTableHead({
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onSort,
    fetchDataAfterMultiDelete,
    theme,
    selected,
    setSelected,
    archieved
}) {
    const { deleteRequests, fetchAllRequests } = RequestActions;
    const { role } = useAuth();

    const handleDelete = async () => {
        const object = {
            properties: selected
        };

        dispatch(
            openConfirmationModal({
                open: true,
                message: 'This action is not reversible.',
                handleConfirm: async () => {
                    const res = await dispatch(deleteRequests(object));

                    if (res?.payload?.status === 200 || res?.payload?.status === 201) {
                        setSelected([]);
                        dispatch(
                            openSnackbar({
                                open: true,
                                message: 'Request(s) deleted successfully.',
                                variant: 'alert',
                                alert: {
                                    color: 'success'
                                },
                                close: true
                            })
                        );

                        fetchDataAfterMultiDelete();
                    } else {
                        dispatch(
                            openSnackbar({
                                open: true,
                                message: response?.payload?.message || 'Internal server error',
                                variant: 'alert',
                                alert: {
                                    color: 'error'
                                },
                                close: true
                            })
                        );
                    }
                }
            })
        );
    };

    const CustomSortIcon = ({ order }) => {
        return order === 'asc' ? (
            <Box sx={{ ml: 1 }}>
                {' '}
                {/* Adds left margin */}
                <svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M8.75 4.76562L5.5 1.51562L2.25 4.76562"
                        stroke="#0E7AF0"
                        strokeWidth="1.11719"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M2.25 9.23437L5.5 12.4844L8.75 9.23437"
                        stroke="#272727"
                        strokeWidth="1.11719"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </Box>
        ) : (
            <Box sx={{ ml: 1 }}>
                {' '}
                {/* Adds left margin */}
                <svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M8.75 4.76562L5.5 1.51562L2.25 4.76562"
                        stroke="#272727"
                        strokeWidth="1.11719"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M2.25 9.23437L5.5 12.4844L8.75 9.23437"
                        stroke="#0E7AF0"
                        strokeWidth="1.11719"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </Box>
        );
    };

    return (
        <TableHead>
            <TableRow sx={{ background: '#EAF2FF' }}>
                {/* <TableCell padding="checkbox" sx={{ pl: 1, pr: 1 }}>
                    <Checkbox
                        color="primary"
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={(event) => onSelectAllClick(event.target.checked)}
                        inputProps={{
                            'aria-label': 'select all desserts'
                        }}
                    />
                </TableCell> */}
                {numSelected > 0 && (
                    <TableCell padding="none" colSpan={12}>
                        <Toolbar
                            sx={{
                                p: 0,
                                pl: 1,
                                pr: 1,
                                ...(numSelected > 0 && {
                                    color: (theme) => theme.palette.secondary.main
                                })
                            }}
                        >
                            <Typography color="#462F4D" variant="h4">
                                {numSelected} Selected
                            </Typography>
                            <Box sx={{ flexGrow: 1 }} />
                            {numSelected > 0 && (
                                <Tooltip title="Delete">
                                    <IconButton size="large" onClick={(event) => handleDelete(event)} sx={{ position: 'sticky', right: 0 }}>
                                        <DeleteIcon color="error" fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            )}
                        </Toolbar>
                    </TableCell>
                )}
                {/* for rm */}
                {numSelected <= 0 &&
                    (role === roles.REGIONAL_MANAGER || role === roles.MARKETING_MANAGER) &&
                    headCells?.map((headCell) => (
                        <TableCell
                            key={headCell.id}
                            align={headCell.align}
                            padding={headCell.disablePadding ? 'none' : 'normal'}
                            sortDirection={orderBy === headCell.id ? order : false}
                            sx={{
                                textTransform: 'capitalize',
                                '& span': {
                                    justifyContent: 'center',
                                    width: headCell.width || 'max-content'
                                }
                            }}
                        >
                            {onSort ? (
                                <TableSortLabel
                                    hideSortIcon
                                    IconComponent={() => <CustomSortIcon order={order} />}
                                    active={orderBy === headCell.id}
                                    direction={orderBy === headCell.id ? order : 'asc'}
                                    onClick={() => onSort(headCell.id)}
                                    sx={{
                                        textTransform: 'capitalize',
                                        '& span': {
                                            justifyContent: 'center',
                                            width: headCell.width || 'max-content'
                                        },
                                        background: '#EAF2FF'
                                    }}
                                >
                                    {headCell.label}
                                    {orderBy === headCell.id ? (
                                        <Box sx={{ ...visuallyHidden }}>{order === 'desc' ? 'sorted descending' : 'sorted ascending'}</Box>
                                    ) : null}
                                </TableSortLabel>
                            ) : (
                                headCell.label
                            )}
                        </TableCell>
                    ))}

                {/* for am */}
                {numSelected <= 0 &&
                    role === roles.APARTMENT_MANAGER &&
                    headCellsAM?.map((headCell) => (
                        <TableCell
                            key={headCell.id}
                            align={headCell.align}
                            padding={headCell.disablePadding ? 'none' : 'normal'}
                            sortDirection={orderBy === headCell.id ? order : false}
                            sx={{
                                textTransform: 'capitalize',
                                '& span': {
                                    justifyContent: 'center',
                                    width: headCell.width || 'max-content'
                                }
                            }}
                        >
                            {onSort ? (
                                <TableSortLabel
                                    hideSortIcon
                                    IconComponent={() => <CustomSortIcon order={order} />}
                                    active={orderBy === headCell.id}
                                    direction={orderBy === headCell.id ? order : 'asc'}
                                    onClick={() => onSort(headCell.id)}
                                    sx={{
                                        textTransform: 'capitalize',
                                        '& span': {
                                            justifyContent: 'center',
                                            width: headCell.width || 'max-content'
                                        },
                                        background: '#EAF2FF'
                                    }}
                                >
                                    {headCell.label}
                                    {orderBy === headCell.id ? (
                                        <Box sx={{ ...visuallyHidden }}>{order === 'desc' ? 'sorted descending' : 'sorted ascending'}</Box>
                                    ) : null}
                                </TableSortLabel>
                            ) : (
                                headCell.label
                            )}
                        </TableCell>
                    ))}

                {/* for admin */}
                {numSelected <= 0 &&
                    role === roles.ADMIN &&
                    (!archieved ? headAdminCell : headArchieveAdminCell)?.map((headCell) => (
                        <TableCell
                            key={headCell.id}
                            align={headCell.align}
                            padding={headCell.disablePadding ? 'none' : 'normal'}
                            sortDirection={orderBy === headCell.id ? order : false}
                            sx={{
                                textTransform: 'capitalize',
                                '& span': {
                                    justifyContent: 'center',
                                    width: headCell.width || 'max-content'
                                },
                                background: '#EAF2FF'
                            }}
                        >
                            {onSort ? (
                                <TableSortLabel
                                    hideSortIcon
                                    IconComponent={() => <CustomSortIcon order={order} />}
                                    active={orderBy === headCell.id}
                                    direction={orderBy === headCell.id ? order : 'asc'}
                                    onClick={() => onSort(headCell.id)}
                                    sx={{
                                        textTransform: 'capitalize',
                                        '& span': {
                                            gap: '5px',
                                            justifyContent: 'center',
                                            width: headCell.width || 'max-content'
                                        },
                                        background: '#EAF2FF',
                                        fontWeight: '700'
                                    }}
                                >
                                    {headCell.label}

                                    {orderBy === headCell.id ? (
                                        <Box sx={{ ...visuallyHidden }}>{order === 'desc' ? 'sorted descending' : 'sorted ascending'}</Box>
                                    ) : null}
                                </TableSortLabel>
                            ) : (
                                headCell.label
                            )}
                        </TableCell>
                    ))}

                {numSelected <= 0 && (
                    <TableCell sortDirection={false} align="center" sx={{ pr: 3 }}>
                        <Typography variant="subtitle1" sx={{ color: theme.palette.mode === 'dark' ? 'grey.600' : 'grey.900' }}>
                            {role === roles.ADMIN ? 'Options' : 'Action'}
                        </Typography>
                    </TableCell>
                )}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    theme: PropTypes.object,
    selected: PropTypes.array,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};

export default EnhancedTableHead;
